import React from 'react';
import { motion } from 'framer-motion';
import { MaximizeIcon } from 'lucide-react';
import { clusterReveal } from '../../../data/snak';
import { clusters } from '../../../data/teaser';
import type { Cluster } from '../../../types/teaser';
const EASE = [0.23, 1, 0.32, 1] as const;
interface ClusterRevealPageProps {
  onEnlarge: (cluster: Cluster) => void;
}
export function ClusterRevealPage({
  onEnlarge
}: ClusterRevealPageProps) {
  return <div className="flex flex-1 flex-col" data-id="element-145" data-mp="l366wxxps0ct">
      <div className="flex items-end justify-between gap-8 px-10 pb-5 pt-8" data-id="element-146" data-mp="p2natmxhspfv">
        <div data-id="element-147" data-mp="p0kaa8yprdww">
          <motion.p initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.24,
          ease: EASE
        }} className="flex items-center gap-2.5 text-[10px] uppercase tracking-micro text-blue" data-id="element-148" data-mp="u29qs44pgjsd">
            <span className="h-1.5 w-1.5 rounded-full bg-mint" aria-hidden="true" data-id="element-149" data-mp="1b9ivi396vvf" />
            {clusterReveal.eyebrow}
          </motion.p>
          <motion.h2 initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.28,
          delay: 0.05,
          ease: EASE
        }} className="mt-3 font-display text-[32px] font-semibold leading-[1.06] tracking-tight text-navy" data-id="element-150" data-mp="9bgf2vzbddop">
            {clusterReveal.headline}
          </motion.h2>
        </div>
        <p className="shrink-0 pb-1 text-[11px] text-mut" data-id="element-151" data-mp="3rn3fxgdlvmy3">{clusterReveal.hint}</p>
      </div>

      <div className="grid flex-1 grid-cols-4 gap-px bg-navy/15" data-id="element-152" data-mp="3mngsyf7z6sc3">
        {clusters.map((cluster, i) => <motion.button key={cluster.id} type="button" onClick={() => onEnlarge(cluster)} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1 + i * 0.07,
        ease: EASE
      }} aria-label={`Enlarge ${cluster.name}`} className="group relative overflow-hidden bg-ink text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-mint" data-id="element-153" data-mp="3dp552kyhu8nc" data-mpi={i}>
            <img src={cluster.image} alt={`AI-assisted OCT segmentation example — ${cluster.name}`} className="absolute inset-0 h-full w-full object-cover object-center transition-transform duration-300 group-hover:scale-[1.04]" data-id="element-154" data-mp="1uu0nqs7nacvz" />
            <div className="scanlines pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-155" data-mp="1lzchozu8wr64" />
            <div className="pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-ink to-transparent" aria-hidden="true" data-id="element-156" data-mp="29pglp8bcisxn" />

            <span className="absolute left-4 top-4 font-display text-[34px] font-bold leading-none tabular-nums text-paper/85" data-id="element-157" data-mp="1zsvi8rez5pvx">
              {String(i + 1).padStart(2, '0')}
            </span>

            <span className="absolute bottom-4 left-4 right-4 flex items-center justify-between gap-2" data-id="element-158" data-mp="ocn8o614lear">
              <span className="text-[10px] uppercase tracking-micro text-sky/85" data-id="element-159" data-mp="tecjploclryu">
                {cluster.name}
              </span>
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-paper/10 opacity-0 transition-opacity duration-150 group-hover:opacity-100" data-id="element-160" data-mp="guped8rim9s4">
                <MaximizeIcon className="h-3.5 w-3.5 text-paper" aria-hidden="true" data-id="element-161" data-mp="us498t0jf9rh" />
              </span>
            </span>
          </motion.button>)}
      </div>
    </div>;
}